export default __webpack_public_path__ + "static/media/lens.196858bd.jpg";